import { TenantResolutionError } from './errors';

const TENANT_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/;
const PATH_SEGMENT_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/;

export const validateTenantId = (tenantId: string): string => {
  if (!tenantId || tenantId !== tenantId.trim() || !TENANT_ID_PATTERN.test(tenantId)) {
    throw new TenantResolutionError('INVALID_TENANT_ID', 'Tenant ID is missing or malformed.');
  }
  return tenantId;
};

const validatePathSegment = (segment: string, label: string): string => {
  if (!segment || segment !== segment.trim() || !PATH_SEGMENT_PATTERN.test(segment)) {
    throw new Error(`${label} is missing or malformed.`);
  }
  return segment;
};

export const tenantRootPath = (tenantId: string): string =>
  `booking-websites/${validateTenantId(tenantId)}`;

export const tenantCollectionPath = (tenantId: string, collectionName: string): string =>
  `${tenantRootPath(tenantId)}/${validatePathSegment(collectionName, 'Collection name')}`;

export const tenantDocumentPath = (
  tenantId: string,
  collectionName: string,
  documentId: string
): string =>
  `${tenantCollectionPath(tenantId, collectionName)}/${validatePathSegment(documentId, 'Document ID')}`;

export const tenantStoragePath = (tenantId: string, relativePath: string): string => {
  if (
    !relativePath ||
    relativePath !== relativePath.trim() ||
    relativePath.startsWith('/') ||
    relativePath.endsWith('/') ||
    relativePath.includes('\\') ||
    Array.from(relativePath).some((character) => character.charCodeAt(0) <= 31)
  ) {
    throw new Error('Storage path is missing or malformed.');
  }
  const segments = relativePath.split('/');
  if (segments.some((segment) => !segment || segment === '.' || segment === '..')) {
    throw new Error('Storage path contains an invalid segment.');
  }
  return `${tenantRootPath(tenantId)}/${relativePath}`;
};

export const encodeHostnameForDocumentId = (hostname: string): string =>
  encodeURIComponent(hostname);
